import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=583b2040&"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports